import { Box } from '@mui/material';
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium';
import { useAppTFunction } from '@retail/app/i18n';
import { NoTableRowsOverlay } from '@retail/components';
import { getDataGridLocalization, MgPrisLocale } from '@retail/utils';
import {
  dataGridCellNoFocusOutlineClass,
  dataGridHorizontalPaddingSmallClass,
} from '@shared/styles';
import clsx from 'clsx';
import { BaseMgSupplierCampaignItem } from '@retail/campaign/types';

interface Props<T extends BaseMgSupplierCampaignItem> {
  items: T[] | undefined;
  language: string;
  columns: GridColDef[];
}

export const AddItemsTable = <T extends BaseMgSupplierCampaignItem>({
  language,
  items,
  columns,
}: Props<T>) => {
  const t = useAppTFunction();

  return (
    <Box sx={{ flexGrow: 1, position: 'relative' }}>
      <Box sx={{ position: 'absolute', inset: 0 }}>
        <DataGridPremium<T>
          columns={columns}
          rows={items}
          getRowId={(row) => `${row.mgSupplierItemId}`}
          getCellClassName={() => clsx(dataGridCellNoFocusOutlineClass)}
          className={dataGridHorizontalPaddingSmallClass}
          localeText={getDataGridLocalization(language as MgPrisLocale)}
          rowHeight={65}
          initialState={{
            pinnedColumns: {
              right: ['actions'],
            },
          }}
          slots={{
            noRowsOverlay: () => <NoTableRowsOverlay noRowsText={t('myAssortment.noItems')} />,
          }}
          disableColumnFilter
          disableColumnMenu
          disableColumnReorder
          disableRowSelectionOnClick
          hideFooter
        />
      </Box>
    </Box>
  );
};
